import { OnInit, Input, Directive } from '@angular/core';

import { ReportCustom } from '@classes/report/report-custom';
import { ChartType } from '@enums/chart-type.enum';
import { ReportTypeCode } from '@enums/report-type-code.enum';
import { ReportDataType } from '@enums/report-data-type.enum';
import { Partition } from '@classes/simulation/partition';
import { ReportDataset } from '@classes/report/report-dataset';
import { Simulation } from '@classes/simulation/simulation';
import { UiService } from '@services/ui.service';
import { ReportService } from '@services/report.service';

@Directive()
export class CustomBaseComponent implements OnInit {
    @Input() customReport: ReportCustom;

    simulations: Simulation[];
    partitions: Partition[];
    rootPartition: Partition;

    years: string[];
    referenceYear: string;
    // Set in CustomCompareComponent and CustomSimuComponent
    dataType: ReportDataType;

    constructor(
        protected uiSrv: UiService,
        protected reportSrv: ReportService
    ) { }

    ngOnInit() {
    }

    onSelectPartition(selectedCodes: string[]): void  {
        this.customReport.partitionsCodes = this.orderSelectedParts(this.partitions, selectedCodes);

        if(this.customReport.partitionsCodes && this.customReport.partitionsCodes.length) {
            this.rootPartition = this.partitions.find(p => p.partitionDetails.articleType === this.customReport.articleType);
            this.generateReportItems();
        } else {
            this.rootPartition = null;
            this.customReport.partitionsCodes = null;
            this.customReport.articleType = null;
        }

        this.reportSrv.editCustomReport(this.customReport);
    }

    protected generateReportItems(): void {
        const title = this.uiSrv.translate('reports.categories.custom.shortLabel') + " " + (this.customReport.id + 1);

        this.customReport.reportItems = [{
            title: {
                shortLabel: title,
                fullLabel: title,
                summary: this.uiSrv.translate('partitions.sunburst.title.summary')
            },
            group: 1000 * (this.customReport.id + 1),
            reportType: {
                code: ReportTypeCode.custom,
                text: {
                    shortLabel: this.uiSrv.translate('reports.categories.custom.shortLabel')
                },
            },
            variations: []
        }, {
            title: {
                shortLabel: this.uiSrv.translate('reports.barChart.title.shortLabel'),
                fullLabel: this.uiSrv.translate('reports.barChart.title.fullLabel'),
                summary: this.uiSrv.translate('reports.barChart.title.summary')
            },
            group: 1000 * (this.customReport.id + 1),
            reportType: {
                code: ReportTypeCode.custom,
                text: {
                    shortLabel: this.uiSrv.translate('reports.categories.custom.shortLabel'),
                    fullLabel: this.uiSrv.translate('reports.categories.custom.fullLabel'),
                    summary: this.uiSrv.translate('reports.categories.custom.summary')
                },
            },
            selectedVariationCode: 'barChart',
            variations: [
                {
                    code: 'barChart',
                    displayType: ChartType.bar,
                    dataType: this.dataType,
                    labels: this.years,
                    stacks: this.simulations.map(s => {
                        return {
                            name: s.userText.shortLabel,
                            datasets: this.generateDatasets(s.partitions, this.customReport.partitionsCodes)
                        };
                    })
                }
            ]
        }];
    }

    // TODO: clean up this shit
    protected generateDatasets(partitions: Partition[], selectedCodes: string[]): ReportDataset[] {
        return partitions.reduce((accumulator, partition) => {
            const datasets: ReportDataset[] = [];
            const pCode = partition.partitionDetails.code;

            if(selectedCodes.indexOf(pCode) !== -1) {
                const label = partition.partitionDetails.text.shortLabel;
                let data: number[];

                switch(this.dataType) {
                    case ReportDataType.amount:
                        data = partition.simulationValues.years
                            .filter(y => y.isEstimated)
                            .map(y => y.amount);
                        break;
                    case ReportDataType.percent:
                    default:
                        data = partition.simulationValues.years
                            .map(y => y.ratio);
                }

                datasets.push({
                    label: label,
                    data: data
                });
            }

            if(partition.partitions) {
                datasets.push(...this.generateDatasets(partition.partitions, selectedCodes));
            }

            return [ ...accumulator, ...datasets];
        }, []);
    }

    protected orderSelectedParts(partitions: Partition[], selectedCodes: string[]): string[] {
        return partitions.reduce((accumulator, partition) => {
            const orderedParts: string[] = [];
            const pCode = partition.partitionDetails.code;

            if(selectedCodes.indexOf(pCode) !== -1) {
                this.customReport.articleType = partition.partitionDetails.articleType;
                orderedParts.push(pCode);
            }

            if(partition.partitions) {
                orderedParts.push(...this.orderSelectedParts(partition.partitions, selectedCodes));
            }

            return [ ...accumulator, ...orderedParts];
        }, []);
    }

}
